// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"75ee947b","453":"1f6c46db"}[chunkId] + ".chunk.js";
};